<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.fullPath)">
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                <v-icon class="me-2">mdi-chart-line</v-icon>
                Department Performance Attendance Dashboard
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport" ref="filterForm">
                  <v-row class="py-3 px-3" align="end" dense>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.from_date"
                        label="From Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        required
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.to_date"
                        label="To Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        required
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="filters.department_id"
                        :items="departments"
                        :item-title="(item) => item.name || item.department_name || ''"
                        item-value="id"
                        label="Department (Optional)"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        clearable
                        hide-details="auto"
                        :loading="departmentsLoading"
                        placeholder="Select department"
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex align-end">
                      <v-btn
                        type="submit"
                        color="primary"
                        variant="flat"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        density="compact"
                        height="40"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Summary Cards -->
          <!-- <v-row v-if="reportData.length > 0" class="mb-3">
            <v-col cols="12" sm="6" md="3">
              <v-card variant="tonal" class="text-center pa-3" color="success">
                <v-card-text class="pa-2">
                  <div class="text-h6 font-weight-bold">{{ formatNumber(overallStats.avgPresentPercent, 2) }}%</div>
                  <div class="text-caption text-grey">Avg Present %</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="tonal" class="text-center pa-3" color="error">
                <v-card-text class="pa-2">
                  <div class="text-h6 font-weight-bold">{{ formatNumber(overallStats.avgAbsentPercent, 2) }}%</div>
                  <div class="text-caption text-grey">Avg Absent %</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="tonal" class="text-center pa-3" color="warning">
                <v-card-text class="pa-2">
                  <div class="text-h6 font-weight-bold">{{ formatNumber(overallStats.totalManpowerShortage) }}</div>
                  <div class="text-caption text-grey">Total Manpower Shortage</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="tonal" class="text-center pa-3" color="info">
                <v-card-text class="pa-2">
                  <div class="text-h6 font-weight-bold">{{ formatNumber(overallStats.avgProductivityImpact, 2) }}%</div>
                  <div class="text-caption text-grey">Avg Productivity Impact</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->

          <!-- Report Table -->
          <v-expansion-panels v-model="reportPanel" >
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                expand-icon="mdi-chevron-down"
                
                >Report Data</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        v-if="reportData.length > 0"
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToExcel"
                          :disabled="!reportData.length"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="!reportData.length"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12"></v-col>
                </v-row>

                <v-progress-linear
                  v-if="loading"
                  indeterminate
                  color="primary"
                  class="mb-4"
                />

                <v-alert
                  v-if="!loading && filteredReportData.length === 0"
                  type="info"
                  variant="tonal"
                >
                  No department performance data found for the selected criteria.
                </v-alert>

                <div v-if="filteredReportData.length">
                  <v-table density="comfortable" class="text-caption table-bordered">
                    <thead>
                      <tr>
                        <th># SL</th>
                        <th>Department</th>
                        <th style="text-align: center;">Total Employees</th>
                        <th style="text-align: center;">Present %</th>
                        <th style="text-align: center;">Absent %</th>
                        <th style="text-align: center;">Late %</th>
                        <th style="text-align: center;">Early %</th>
                        <th style="text-align: center;">Total OT (hrs)</th>
                        <th style="text-align: center;">Manpower Shortage</th>
                        <th style="text-align: center;">Productivity Impact %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in filteredReportData" :key="`${row.department}-${index}`">
                        <td>{{ index + 1 }}</td>
                        <td class="font-weight-medium">{{ row.department || '-' }}</td>
                        <td style="text-align: center;">{{ formatNumber(row.total_employees) }}</td>
                        <td style="text-align: center;">
                          <v-chip 
                            :color="getPercentColor(row.present_percent, true)" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.present_percent, 2) }}%
                          </v-chip>
                        </td>
                        <td style="text-align: center;">
                          <v-chip 
                            :color="getPercentColor(row.absent_percent, false)" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.absent_percent, 2) }}%
                          </v-chip>
                        </td>
                        <td style="text-align: center;">
                          <v-chip 
                            color="warning" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.late_percent, 2) }}%
                          </v-chip>
                        </td>
                        <td style="text-align: center;">
                          <v-chip 
                            color="info" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.early_percent, 2) }}%
                          </v-chip>
                        </td>
                        <td style="text-align: center;">{{ formatNumber(row.total_ot_hours, 2) }}</td>
                        <td style="text-align: center;">
                          <v-chip 
                            :color="row.manpower_shortage > 0 ? 'error' : 'success'" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.manpower_shortage) }}
                          </v-chip>
                        </td>
                        <td style="text-align: center;">
                          <v-chip 
                            :color="getProductivityColor(row.productivity_impact)" 
                            size="small" 
                            variant="outlined"
                          >
                            {{ formatNumber(row.productivity_impact, 2) }}%
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot v-if="filteredReportData.length > 0">
                      <tr style="font-weight: bold; color: #000000;">
                        <td colspan="2" style="text-align: right; padding: 12px;">Total/Average:</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.total_employees) }}</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.avg_present_percent, 2) }}%</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.avg_absent_percent, 2) }}%</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.avg_late_percent, 2) }}%</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.avg_early_percent, 2) }}%</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.total_ot_hours, 2) }}</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.total_manpower_shortage) }}</td>
                        <td style="text-align: center; padding: 12px;">{{ formatNumber(filteredTotals.avg_productivity_impact, 2) }}%</td>
                      </tr>
                    </tfoot>
                  </v-table>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, onMounted, getCurrentInstance } from 'vue'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import { formatDateView, formatDateDash } from "@/plugins/helpers";


const store = useStore()
const instance = getCurrentInstance()
const appContext = instance?.appContext

// Panel state
const panel = ref([0])
const reportPanel = ref([0])

// Loading states
const loading = ref(false)
const departmentsLoading = ref(false)

// Search
const search = ref('')

// Filters
const filters = reactive({
  from_date: '',
  to_date: '',
  department_id: null
})

// Data
const reportData = ref([])
const departments = ref([])

const formatNumber = (value, fraction = 0) => {
  if (value === undefined || value === null || isNaN(value)) return '-'
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction
  })
}

const getPercentColor = (percent, isPositive) => {
  if (isPositive) {
    if (percent >= 90) return 'success'
    if (percent >= 75) return 'info'
    if (percent >= 60) return 'warning'
    return 'error'
  } else {
    if (percent <= 5) return 'success'
    if (percent <= 10) return 'info'
    if (percent <= 20) return 'warning'
    return 'error'
  }
}

const getProductivityColor = (impact) => {
  if (impact <= 5) return 'success'
  if (impact <= 10) return 'info'
  if (impact <= 20) return 'warning'
  return 'error'
}

// Filtered report data based on search
const filteredReportData = computed(() => {
  if (!search.value) {
    return reportData.value
  }
  
  const searchLower = search.value.toLowerCase()
  return reportData.value.filter(row => {
    const department = (row.department || '').toLowerCase()
    return department.includes(searchLower)
  })
})

// Computed totals
const totals = computed(() => {
  if (reportData.value.length === 0) {
    return {
      total_employees: 0,
      avg_present_percent: 0,
      avg_absent_percent: 0,
      avg_late_percent: 0,
      avg_early_percent: 0,
      total_ot_hours: 0,
      total_manpower_shortage: 0,
      avg_productivity_impact: 0
    }
  }

  const sums = reportData.value.reduce(
    (acc, row) => {
      acc.total_employees += Number(row.total_employees) || 0
      acc.present_percent += Number(row.present_percent) || 0
      acc.absent_percent += Number(row.absent_percent) || 0
      acc.late_percent += Number(row.late_percent) || 0
      acc.early_percent += Number(row.early_percent) || 0
      acc.total_ot_hours += Number(row.total_ot_hours) || 0
      acc.manpower_shortage += Number(row.manpower_shortage) || 0
      acc.productivity_impact += Number(row.productivity_impact) || 0
      return acc
    },
    {
      total_employees: 0,
      present_percent: 0,
      absent_percent: 0,
      late_percent: 0,
      early_percent: 0,
      total_ot_hours: 0,
      manpower_shortage: 0,
      productivity_impact: 0
    }
  )

  const count = reportData.value.length
  return {
    total_employees: sums.total_employees,
    avg_present_percent: count > 0 ? sums.present_percent / count : 0,
    avg_absent_percent: count > 0 ? sums.absent_percent / count : 0,
    avg_late_percent: count > 0 ? sums.late_percent / count : 0,
    avg_early_percent: count > 0 ? sums.early_percent / count : 0,
    total_ot_hours: sums.total_ot_hours,
    total_manpower_shortage: sums.manpower_shortage,
    avg_productivity_impact: count > 0 ? sums.productivity_impact / count : 0
  }
})

// Computed totals for filtered data
const filteredTotals = computed(() => {
  if (filteredReportData.value.length === 0) {
    return {
      total_employees: 0,
      avg_present_percent: 0,
      avg_absent_percent: 0,
      avg_late_percent: 0,
      avg_early_percent: 0,
      total_ot_hours: 0,
      total_manpower_shortage: 0,
      avg_productivity_impact: 0
    }
  }

  const sums = filteredReportData.value.reduce(
    (acc, row) => {
      acc.total_employees += Number(row.total_employees) || 0
      acc.present_percent += Number(row.present_percent) || 0
      acc.absent_percent += Number(row.absent_percent) || 0
      acc.late_percent += Number(row.late_percent) || 0
      acc.early_percent += Number(row.early_percent) || 0
      acc.total_ot_hours += Number(row.total_ot_hours) || 0
      acc.manpower_shortage += Number(row.manpower_shortage) || 0
      acc.productivity_impact += Number(row.productivity_impact) || 0
      return acc
    },
    {
      total_employees: 0,
      present_percent: 0,
      absent_percent: 0,
      late_percent: 0,
      early_percent: 0,
      total_ot_hours: 0,
      manpower_shortage: 0,
      productivity_impact: 0
    }
  )

  const count = filteredReportData.value.length
  return {
    total_employees: sums.total_employees,
    avg_present_percent: count > 0 ? sums.present_percent / count : 0,
    avg_absent_percent: count > 0 ? sums.absent_percent / count : 0,
    avg_late_percent: count > 0 ? sums.late_percent / count : 0,
    avg_early_percent: count > 0 ? sums.early_percent / count : 0,
    total_ot_hours: sums.total_ot_hours,
    total_manpower_shortage: sums.manpower_shortage,
    avg_productivity_impact: count > 0 ? sums.productivity_impact / count : 0
  }
})

// Overall stats for summary cards
const overallStats = computed(() => {
  return {
    avgPresentPercent: totals.value.avg_present_percent,
    avgAbsentPercent: totals.value.avg_absent_percent,
    totalManpowerShortage: totals.value.total_manpower_shortage,
    avgProductivityImpact: totals.value.avg_productivity_impact
  }
})

// Computed for company info
const getCurrentCompany = computed(() => {
  return store.getters.getCurrentCompany || {}
})

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || ''
})



const setDefaultDates = () => {
  const today = new Date()
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)
  filters.from_date = firstDay
  filters.to_date = lastDay
}

// Methods
const loadDepartments = async () => {
  departmentsLoading.value = true
  try {
    const response = await store.dispatch('getDepartments')
    if (response.data.success && response.data.data) {
      departments.value = response.data.data
    } else if (response.data.data) {
      departments.value = response.data.data
    } else {
      departments.value = []
    }
  } catch (error) {
    departments.value = []
    toast.error(error.message || 'Failed to load departments')
  } finally {
    departmentsLoading.value = false
  }
}

const resetFilters = () => {
  setDefaultDates()
  filters.department_id = null
  reportData.value = []
}

const loadReport = async () => {
  if (!filters.from_date || !filters.to_date) {
    toast.error('Please select both From Date and To Date')
    return
  }

  loading.value = true
  try {
    const params = {
      from_date: formatDateDash(filters.from_date),
      to_date: formatDateDash(filters.to_date),
      department_id: filters.department_id || undefined
    }

    const response = await store.dispatch('getDepartmentPerformanceReport', params)

    if (response.success) {
      reportData.value = response.data || []
      if (reportData.value.length === 0) {
        toast.info('No data found for the selected criteria')
      }
    } else {
      toast.error(response.message || 'Failed to load report')
      reportData.value = []
    }
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || 'Failed to load report')
    reportData.value = []
  } finally {
    loading.value = false
  }
}

// Export to Excel
const exportToExcel = () => {
  if (!reportData.value.length) {
    toast.warning('No data to export')
    return
  }

  const data = [
    ['Department Performance Attendance Dashboard'],
    [`From Date: ${formatDateView(filters.from_date)} to ${formatDateView(filters.to_date)}`]
  ]
  
  if (filters.department_id) {
    const selectedDepartment = departments.value.find(d => d.id === filters.department_id)
    if (selectedDepartment) {
      data.push([`Department: ${selectedDepartment.name || selectedDepartment.department_name || ''}`])
    }
  }
  
  data.push([], ['# SL', 'Department', 'Total Employees', 'Present %', 'Absent %', 'Late %', 'Early %', 'Total OT (hrs)', 'Manpower Shortage', 'Productivity Impact %'], [])

  // Add data rows
  reportData.value.forEach((row, index) => {
    data.push([
      index + 1,
      row.department || '-',
      formatNumber(row.total_employees),
      formatNumber(row.present_percent, 2) + '%',
      formatNumber(row.absent_percent, 2) + '%',
      formatNumber(row.late_percent, 2) + '%',
      formatNumber(row.early_percent, 2) + '%',
      formatNumber(row.total_ot_hours, 2),
      formatNumber(row.manpower_shortage),
      formatNumber(row.productivity_impact, 2) + '%'
    ])
  })

  // Add totals row
  if (reportData.value.length > 0) {
    data.push([])
    data.push([
      '', 'Total/Average:',
      formatNumber(totals.value.total_employees),
      formatNumber(totals.value.avg_present_percent, 2) + '%',
      formatNumber(totals.value.avg_absent_percent, 2) + '%',
      formatNumber(totals.value.avg_late_percent, 2) + '%',
      formatNumber(totals.value.avg_early_percent, 2) + '%',
      formatNumber(totals.value.total_ot_hours, 2),
      formatNumber(totals.value.total_manpower_shortage),
      formatNumber(totals.value.avg_productivity_impact, 2) + '%'
    ])
  }

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
    proxy.$exportTableToExcel(data, 'department_performance_dashboard_' + proxy.$fileDate())
  }
}

// Export to PDF
const exportToPDF = async () => {
  if (!reportData.value.length) {
    toast.warning('No data to export')
    return
  }

  const company = getCurrentCompany.value
  const fileServerUrl = getFileServerUrl.value
  const selectedDepartment = filters.department_id 
    ? departments.value.find(d => d.id === filters.department_id)
    : null

  let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`)
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Department Performance Attendance Dashboard</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
          body { font-family: 'Arimo', sans-serif; margin: 0px; }
          .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
          .invoice-header img { max-height: 70px; max-width: 150px; }
          .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 12px; }
          .table th { background-color: #f0f0f0; color: #333; }
          .text-end { text-align: right; }
          .text-center { text-align: center; }
          h4 { font-size: 20px; color: #333; }
          p { font-size: 14px; color: #555; margin: 2px 0; }
          strong { font-weight: bold; color: #333; }
          @page { margin: 0.5in; size: letter; }
          .logo-container { display:flex; align-items:center; }
          .logo-container img { margin-left: 10px; }
          .table { width: 100%; border-collapse: collapse; table-layout: auto; }
          thead { display: table-header-group; }
          .totals-row { page-break-inside: avoid; }
          .totals-row td { font-weight: bold; background-color: #f5f5f5 !important; }
        </style>
      </head>
      <body>
        <div class="container-fluid position-relative">
          <div class="invoice-header">
            <div>
              <h4 class="text-uppercase">${company?.name || 'Company Name'}</h4>
              <p style="width:65%">${company?.address || ''}</p>
              <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ''}</p>
              <p><i class="mdi mdi-email-outline"></i> ${company?.email || ''}</p>
              ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ''}
            </div>
            <div class="logo-container">
              ${company?.logo_thumb ? `<img src="${fileServerUrl}${company.logo_thumb}" alt="Logo" class="img-fluid">` : ''}
            </div>
          </div>
          <h4 class="text-center my-4"><strong>DEPARTMENT PERFORMANCE ATTENDANCE DASHBOARD</strong></h4>
          <div class="row mb-3">
            <div class="col-sm-8">
              <p><strong>Period:</strong> ${formatDateView(filters.from_date)} to ${formatDateView(filters.to_date)}</p>
              ${selectedDepartment ? `<p><strong>Department:</strong> ${selectedDepartment.name || selectedDepartment.department_name || ''}</p>` : ''}
            </div>
            <div class="col-sm-4 text-end">
              <p><strong>Total Records:</strong> ${reportData.value.length}</p>
            </div>
          </div>
          <table class="table mt-4">
            <thead>
              <tr>
                <th>SN</th>
                <th>Department</th>
                <th class="text-center">Total Employees</th>
                <th class="text-center">Present %</th>
                <th class="text-center">Absent %</th>
                <th class="text-center">Late %</th>
                <th class="text-center">Early %</th>
                <th class="text-center">Total OT (hrs)</th>
                <th class="text-center">Manpower Shortage</th>
                <th class="text-center">Productivity Impact %</th>
              </tr>
            </thead>
            <tbody>
              ${reportData.value.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td><strong>${row.department || '-'}</strong></td>
                  <td class="text-center">${formatNumber(row.total_employees)}</td>
                  <td class="text-center">${formatNumber(row.present_percent, 2)}%</td>
                  <td class="text-center">${formatNumber(row.absent_percent, 2)}%</td>
                  <td class="text-center">${formatNumber(row.late_percent, 2)}%</td>
                  <td class="text-center">${formatNumber(row.early_percent, 2)}%</td>
                  <td class="text-center">${formatNumber(row.total_ot_hours, 2)}</td>
                  <td class="text-center">${formatNumber(row.manpower_shortage)}</td>
                  <td class="text-center">${formatNumber(row.productivity_impact, 2)}%</td>
                </tr>
              `).join('')}
              <tr class="totals-row">
                <td colspan="2" class="text-end">Total/Average:</td>
                <td class="text-center">${formatNumber(totals.value.total_employees)}</td>
                <td class="text-center">${formatNumber(totals.value.avg_present_percent, 2)}%</td>
                <td class="text-center">${formatNumber(totals.value.avg_absent_percent, 2)}%</td>
                <td class="text-center">${formatNumber(totals.value.avg_late_percent, 2)}%</td>
                <td class="text-center">${formatNumber(totals.value.avg_early_percent, 2)}%</td>
                <td class="text-center">${formatNumber(totals.value.total_ot_hours, 2)}</td>
                <td class="text-center">${formatNumber(totals.value.total_manpower_shortage)}</td>
                <td class="text-center">${formatNumber(totals.value.avg_productivity_impact, 2)}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </body>
    </html>
  `)
  printWindow.moveTo(0, 0)
  printWindow.focus()
  await new Promise(resolve => setTimeout(resolve, 500))
  printWindow.print()
  printWindow.close()
}

// Initialize
onMounted(async () => {
  await loadDepartments()
  setDefaultDates()
})
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}

.table-bordered :deep(th),
.table-bordered :deep(td) {
  border: 1px solid #000000 !important;
}

.table-bordered :deep(table) {
  border-collapse: collapse;
}

.gap-2 {
  gap: 8px;
}

.panel-header {
  font-weight: 600;
}
</style>

